import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GridFilterSelect } from './GridFilterSelect';
import { UserRole } from '@api/models/enums/UserRole';

const options = [UserRole.ExternalManager, UserRole.ExternalWorker];

interface Props {
  value?: UserRole;
  onChange: (value?: UserRole) => void;
}

export const GridFilterSupplierEmployeeRole: FC<Props> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <GridFilterSelect
      value={value}
      options={options}
      onChange={onChange}
      getOptionId={(option: UserRole) => option}
      getOptionName={(option: UserRole) => t(`user.role.${option}`)}
    />
  );
};
